import { GlobalContext } from "components/GlobalContext";
import { createFilterableArrayColumnDefinition, IColumnDefinition } from "components/SortableTable";
import ISalesZone, { ISalesZoneCreateOrUpdate, ISalesZoneFilters, ISalesZoneInitResult } from "models/sql/ISalesZone";
import { useContext, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import SalesZoneService from "services/SalesZoneService";
import CommonLookupDisplay from "components/CommonLookupDisplay";

interface ISalesZonesLookupProps {
    baseData?: ISalesZoneInitResult;
}

const COUNTRIES_FILTER_KEY = "countries";

const SalesZonesLookup = (props: ISalesZonesLookupProps) => {
    const globalContext = useContext(GlobalContext);
    const globalContextRef = useRef(globalContext);
    globalContextRef.current = globalContext;
    const [filter, setFilter] = useState<ISalesZoneFilters>({});
    const navigate = useNavigate();

    const getColumns = (): IColumnDefinition<ISalesZone, ISalesZoneFilters>[] => {
        return [
            createFilterableArrayColumnDefinition<ISalesZone, ISalesZoneFilters>(
                globalContext,
                "name",
                "names",
                true,
                filter,
                undefined,
                (value, row) => <td className="align-top" key={`name${row.salesZoneId}`}>
                    {value}</td>,
                "Name"),
            createFilterableArrayColumnDefinition<ISalesZone, ISalesZoneFilters>(
                globalContext,
                "country",
                "countries",
                true,
                filter,
                undefined,
                (value, row) => <td className="align-top" key={`company${row.salesZoneId}`}>
                    {value}
                </td>,
                "Country"),
            createFilterableArrayColumnDefinition<ISalesZone, ISalesZoneFilters>(
                globalContext,
                // @ts-ignore
                "dealerName",
                "dealerNames",
                true,
                filter,
                undefined,
                (value, row) => <td className="align-top" key={`dealerName${row.salesZoneId}`}>
                    {row.dealer?.dealerName}
                </td>,
                "Dealer"),
            createFilterableArrayColumnDefinition<ISalesZone, ISalesZoneFilters>(
                globalContext,
                // @ts-ignore
                "repName",
                "repNames",
                true,
                filter,
                undefined,
                (value, row) => <td className="align-top" key={`repName${row.salesZoneId}`}>
                    {row.salesRep?.fullName}
                </td>,
                "Rep")
        ];
    };

    const getTools = () => [
        <>
            {
                globalContext.roles.some(r => r === "Web.Admin") &&
                <Button
                    key="createnew"
                    variant="success"
                    className="full-sm"
                    onClick={() => { navigate(`/SalesZones/Detail/`) }}>Create New</Button>
            }
        </>
    ];

    return (
        <CommonLookupDisplay<ISalesZoneFilters, ISalesZone, ISalesZoneCreateOrUpdate>
            baseFilters={{
                sortBys: ["SalesZoneId"],
                sortDescending: true
            }}
            filterHints={{
                names: "Array",
                salesRepIds: "Array",
                dealerIds: "Array",
                countries: "Array",
                types: "Array",
                sortBys: "Array",
                sortDescending: "Boolean"
            }}
            dataTypeName="Representative"
            dataTypeNamePlural="Representatives"
            pathName="SalesZones"
            primaryIdKey="salesZoneId"
            className=""
            countriesFilterKey={COUNTRIES_FILTER_KEY}
            filter={filter}
            setFilter={setFilter}
            columnDefinitions={getColumns()}
            service={SalesZoneService}
            tools={getTools()}
            preventLoad={!globalContext.roles.some(r => r === "Web.SalesZones.Lookup")}
        />
    );
}

export default SalesZonesLookup;
